import { Request } from "@konv/http";

export class EnvironmentAPI {
  static async request({
    endpoint = "/",
    method = "GET",
    headers = {},
    query,
    data,
  }) {
    return await Request.request({
      endpoint: endpoint,
      method: method,
      headers: headers,
      service: "environments",
      ignoreVersion: true,
      params: query,
      data: data,
    });
  }

  static async getS3Configurations(alias) {
    try {
      return await fetch(
        `${
          process.env.NEXT_PUBLIC_CDN_ENVIRONMENT_CONFIGURATIONS
        }/${alias}.json?t=${Date.now()}`
      ).then((r) => {
        if (r === null) {
          return r;
        }
        return r.json();
      });
    } catch (err) {
      return {};
    }
  }

  static async getEnvironmentByCode(code) {
    return await EnvironmentAPI.request({
      endpoint: `/code/${code}`,
    });
  }

  static async getExternalCredentials(environment_id) {
    return await EnvironmentAPI.request({
      endpoint: `/app/${environment_id}/configurations/external_credentials`,
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_APP_KEY}`,
      },
    });
  }
}
